module.exports = __webpack_public_path__ + "img/telegram.a1994736.svg";